/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Password_Has_Been_Reset_SInputs */

const en_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your password has been reset successfully. Redirecting to login...`)
};

const es_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu contraseña se ha restablecido correctamente. Redirigiendo al inicio de sesión...`)
};

const fr_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre mot de passe a été réinitialisé avec succès. Redirection vers la page de connexion...`)
};

const de_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Passwort wurde erfolgreich zurückgesetzt. Weiterleitung zur Anmeldung...`)
};

const ja_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードは正常にリセットされました。ログイン画面にリダイレクトしています...`)
};

const zh_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的密码已重置成功。正在重定向到登录页面...`)
};

const ar_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت إعادة تعيين كلمة المرور بنجاح. جاري التوجيه إلى صفحة تسجيل الدخول...`)
};

const id_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata sandi Anda telah berhasil diatur ulang. Mengalihkan ke halaman login...`)
};

const it_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua password è stata reimpostata con successo. Reindirizzamento al login in corso...`)
};

const ru_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш пароль успешно сброшен. Перенаправление на страницу входа...`)
};

const pt_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua senha foi redefinida com sucesso. Redirecionando para o login...`)
};

const ko_your_password_has_been_reset_s = /** @type {(inputs: Your_Password_Has_Been_Reset_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호가 성공적으로 재설정되었습니다. 로그인 페이지로 이동합니다...`)
};

/**
* | output |
* | --- |
* | "Your password has been reset successfully. Redirecting to login..." |
*
* @param {Your_Password_Has_Been_Reset_SInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_password_has_been_reset_s = /** @type {((inputs?: Your_Password_Has_Been_Reset_SInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Password_Has_Been_Reset_SInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_password_has_been_reset_s(inputs)
	if (locale === "es") return es_your_password_has_been_reset_s(inputs)
	if (locale === "fr") return fr_your_password_has_been_reset_s(inputs)
	if (locale === "de") return de_your_password_has_been_reset_s(inputs)
	if (locale === "ja") return ja_your_password_has_been_reset_s(inputs)
	if (locale === "zh") return zh_your_password_has_been_reset_s(inputs)
	if (locale === "ar") return ar_your_password_has_been_reset_s(inputs)
	if (locale === "id") return id_your_password_has_been_reset_s(inputs)
	if (locale === "it") return it_your_password_has_been_reset_s(inputs)
	if (locale === "ru") return ru_your_password_has_been_reset_s(inputs)
	if (locale === "pt") return pt_your_password_has_been_reset_s(inputs)
	return ko_your_password_has_been_reset_s(inputs)
});